import { render, staticRenderFns } from "./ImportOrdersFilter.vue?vue&type=template&id=0400484c&scoped=true"
import script from "./ImportOrdersFilter.vue?vue&type=script&lang=js"
export * from "./ImportOrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0400484c",
  null
  
)

export default component.exports